import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  container: {
    border: '1px solid rgba(233, 235, 245, 1)',
    borderRadius: '4px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
    scrollbarWidth: 'none !important',
    msOverflowStyle: 'none !important',
    maxHeight: '750px',
    backgroundColor: '#fff',

    [theme.breakpoints.down('lg')]: {
      padding: '20px',
      gap: '20px',
      maxHeight: '680px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '16px',
      gap: '16px',
      maxHeight: '600px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '12px',
      gap: '12px',
      maxHeight: '520px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '10px',
      gap: '10px',
      maxHeight: '480px',
    },
  },

  row: {
    height: '44px',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    display: 'flex',
    gap: '16px',
    padding: '10px',
    // border: '1px solid rgba(233, 235, 245, 0.7)',
    borderRadius: 6,
    alignItems: 'center',

    [theme.breakpoints.down('lg')]: {
      height: '42px',
      gap: '14px',
      padding: '9px',
    },
    [theme.breakpoints.down('md')]: {
      height: '40px',
      gap: '12px',
      padding: '8px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '38px',
      gap: '10px',
      padding: '8px',
    },
    [theme.breakpoints.down('xs')]: {
      height: '36px',
      gap: '8px',
      padding: '6px',
    },
  },

  dateBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '150px',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.down('lg')]: { width: '140px' },
    [theme.breakpoints.down('md')]: { width: '120px' },
    [theme.breakpoints.down('sm')]: { width: '110px' },
    [theme.breakpoints.down('xs')]: { width: '96px' },
  },

  dateText: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(95, 96, 113, 1)',

    [theme.breakpoints.down('md')]: { fontSize: '11.5px' },
    [theme.breakpoints.down('sm')]: { fontSize: '11px' },
    [theme.breakpoints.down('xs')]: { fontSize: '10.5px' },
  },

  iconWrapper: {
    width: '32px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.down('md')]: { width: '30px' },
    [theme.breakpoints.down('sm')]: { width: '28px' },
    [theme.breakpoints.down('xs')]: { width: '26px' },
  },

  iconCircle: {
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid rgba(233, 235, 245, 1)',
    borderRadius: '50px',
    backgroundColor: 'rgba(250, 250, 254, 1)',
    padding: '5px',

    [theme.breakpoints.down('md')]: {
      width: '30px',
      height: '30px',
      padding: '4px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '28px',
      height: '28px',
      padding: '4px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '26px',
      height: '26px',
      padding: '3px',
    },
  },

  messageBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    flexGrow: 1,
    minWidth: 0, // allow ellipsis if added later
  },

  messageText: {
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(43, 44, 53, 1)',
    flexGrow: 1,

    [theme.breakpoints.down('md')]: { fontSize: '13.5px' },
    [theme.breakpoints.down('sm')]: { fontSize: '13px' },
    [theme.breakpoints.down('xs')]: { fontSize: '12.5px' },
  },

  userText: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(95, 96, 113, 1)',
    flexGrow: 1,

    [theme.breakpoints.down('md')]: { fontSize: '11.5px' },
    [theme.breakpoints.down('sm')]: { fontSize: '11px' },
    [theme.breakpoints.down('xs')]: { fontSize: '10.5px' },
  },

  noAudit: {
    textAlign: 'center',
    width: '100%',
    padding: '20px',
    [theme.breakpoints.down('md')]: { padding: '16px' },
    [theme.breakpoints.down('sm')]: { padding: '12px' },
  },
}));

const AuditTrailViewer = (props) => {
  const { auditTrail, chartUniqueId } = props;
  const classes = useStyles();

  const getOperationIcon = (formName, operation, formType) => {
    const operationIcons = {
      Created: '/media/svg/AddTaskObligationAudit.svg',
      taskCreated: '/media/svg/AddTaskObligationAudit.svg',
      Accept: '/media/svg/tickObligations.svg',
      "Assign document": '/media/svg/assignedObligationAudit.svg',
      assigned: '/media/svg/assignedObligationAudit.svg',
      deleted: '/media/svg/deleteTaskAudit.svg',
      taskUpdated: '/media/svg/editObligationAudit.svg',
      forwarded: '/media/svg/forwardObligationAudit.svg',
      messaged: '/media/svg/messageObligationAudit.svg',
      Modify: '/media/svg/moveObligationsAudit.svg',
      rejectObligation: '/media/svg/tickObligations.svg',
      taskDelete: '/media/svg/deleteTaskAudit.svg',
    };

    if (operation === 'Modify' && formType === "Reject") {
      return operationIcons["rejectObligation"]
    }
    if (formName === "workflow" && formType === "Comment") {
      return operationIcons["messaged"]
    }
    return operationIcons[operation];
  }

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const formatted = date.toLocaleString("en-US", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return formatted.replace(/\//g, "-");
  }

  return (
    <div className={`${classes.container} myScrollContainer`}>
      {props.formData?.[chartUniqueId + '_audit_Trails_Obligations_loading'] ? (
        props.loader
      ) : auditTrail && auditTrail.length > 0 ? (
        auditTrail.map((res, index) => {
          const iconSrc =
            getOperationIcon(res.formName, res.operation, res.formType) ||
            '/media/svg/tickObligations.svg';
          return (
            <div key={index} className={classes.row}>
              <div className={classes.dateBox}>
                <Typography className={classes.dateText}>
                  {formatDate(res['createdDate'])}
                </Typography>
              </div>
              <div className={classes.iconWrapper}>
                <div className={classes.iconCircle}>
                  <img src={iconSrc} alt={iconSrc} width="25" height="25" />
                </div>
              </div>
              <div className={classes.messageBox}>
                <Typography className={classes.messageText}>
                  {res['message']}
                </Typography>
                <Typography className={classes.userText}>
                  {`By ${res['userName']}`}
                </Typography>
              </div>
            </div>
          );
        })
      ) : (
        <Typography className={`${classes.messageText} ${classes.noAudit}`}>
          No audit history available yet.
        </Typography>
      )}
    </div>
  );
}

export default AuditTrailViewer
